var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trix-start"},[_c('input',{attrs:{"id":"trix","type":"hidden","name":_vm.name},domProps:{"value":_vm.value}}),_vm._v(" "),_c('trix-editor',{ref:"trix",attrs:{"placeholder":"Write a reply...","input":"trix"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72294011","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wysiwyg.vue
// module id = null
// module chunks = 